export default __webpack_public_path__ + "static/media/H4011.4.6ea4ec50.mp3";